<template>
  <mt-tabbar v-model="message" fixed>
    <mt-tab-item id="home">
      <img slot="icon" src="../assets/home.png">
      主页
    </mt-tab-item>
    <mt-tab-item id="my">
      <img slot="icon" src="../assets/my.png">
      我的
    </mt-tab-item>
  </mt-tabbar>
</template>

<script>
export default {
  data() {
    return {
      //选中的tabbar值message为外面页面传入的值selected
      message: this.selected,
    }
  },
  props: {
    selected: String,
  },
  watch: {
    message: function (val, oldVal) {
      // 这里就可以通过 val 的值变更来确定去向
      switch (val) {
        case 'home':
          this.$router.push('/');
          break;
        case 'my':
          this.$router.push('/exit');
          break;
      }
    }
  },
}
</script>

<style>
body {
  margin: 0;
  padding: 0;
}

ul li {
  list-style: none;
}

.mint-tabbar > .mint-tab-item.is-selected {
  color: red;
  font-weight: bold;
  background: #fff;
}

.mint-tabbar {
  border: 0;
  background: #fff;
  border-color: #fff;
}
</style>


// WEBPACK FOOTER //
// src/components/tabbar.vue